import TUpload from './upload.vue'

TUpload.install = Vue => {
  Vue.component(TUpload.name, TUpload)
}

export default TUpload



// WEBPACK FOOTER //
// ./src/module/upload/index.js